"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const field_1 = require("../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Shared.Dealer';
const optionalDateTime = (description) => effect_1.Schema.optionalWith((0, field_1.dateTime)(description), { exact: true }).annotations({ description });
exports.Location = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Dealer location id'),
    code: (0, field_1.nonEmpty)('Dealer code'),
    name: (0, field_1.nonEmpty)('Dealer or dealership name'),
    country: (0, field_1.nonEmpty)('Country'),
    region: (0, field_1.nullableString)('null for locations created or updated through this API; a region code (e.g. eu) only on seeded rows that were never updated'),
    address: (0, field_1.optionalNullableString)('Street address'),
    city: (0, field_1.optionalNullableString)('City'),
    zip: (0, field_1.optionalNullableString)('ZIP / postal code'),
    state: (0, field_1.optionalNullableString)('State, province, or region'),
    phone: (0, field_1.optionalNullableString)('Phone number'),
    email: (0, field_1.optionalNullableString)('Contact email'),
    website: (0, field_1.optionalNullableString)('Website URL'),
    contactPersonName: (0, field_1.optionalNullableString)('Name of the owner or contact person'),
    createdAt: optionalDateTime('ISO-8601 time of the last save(). PUT resets it to the update time. Omitted on rows inserted outside save().'),
    updatedAt: optionalDateTime('ISO-8601 last update time. Omitted on rows inserted outside save().'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Location`,
    description: 'Stored dealer location',
});
//# sourceMappingURL=dealer.js.map